export enum QuestRewardTypes {
	RESOURCE = "RESOURCE",
	RESOURCE_INCOME = "RESOURCE_INCOME",
	GET_BUILDING_TO_STOCK = "GET_BUILDING_TO_STOCK",
	UNLOCK_BUILDING = "UNLOCK_BUILDING",
	UNLOCK_MECHANIC = "UNLOCK_MECHANIC",
	UNLOCK_UPGRADE = "UNLOCK_UPGRADE",
	UNLOCK_EVENT = "UNLOCK_EVENT",
	UNLOCK_SETTLEMENT = "UNLOCK_SETTLEMENT",
	CHESTS_PLACEMENT = "CHESTS_PLACEMENT",
	EXPLORATION_SPEED = "EXPLORATION_SPEED",
	PIGGY_BANK = "PIGGY_BANK",
}
